import React, { useState } from "react";
import { UserSwitch, SignOut } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import ConfirmDialog from "@/components/ConfirmDialog";

export default function ImpersonationBanner() {
  const { user, endImpersonation } = useAuth();
  const nav = useNavigate();
  const [confirming, setConfirming] = useState(false);
  if (!user?.impersonating) return null;

  const stop = async () => {
    setConfirming(false);
    const back = await endImpersonation();
    if (back) {
      toast.success(`Back to ${back.email}`);
      nav("/app/global-admin");
    }
  };

  return (
    <>
      <div
        data-testid="impersonation-banner"
        className="bg-amber-500 text-black text-xs font-semibold px-4 h-10 flex items-center justify-between gap-3 shadow-md"
      >
        <div className="flex items-center gap-2 min-w-0">
          <UserSwitch size={14} weight="fill" />
          <span className="truncate">
            Clariva support session · <strong>{user.impersonating.actor_email}</strong> is viewing as <strong>{user.email}</strong>. All actions are audit-logged.
          </span>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => setConfirming(true)}
          data-testid="end-impersonation-btn"
          className="h-7 gap-1.5 text-black hover:bg-black/10"
        >
          <SignOut size={12} /> Exit support session
        </Button>
      </div>

      <ConfirmDialog
        open={confirming}
        onOpenChange={setConfirming}
        title="End support session?"
        description={`You will return to your own account (${user.impersonating.actor_email}). The impersonation audit log will be closed and stamped with the end time.`}
        actionLabel="Yes, end session"
        cancelLabel="Keep viewing"
        onConfirm={stop}
        testId="end-impersonation-dialog"
      />
    </>
  );
}
